// CONSTANTS are all caps.
const NS = 'NearbyEventContainerBlock';
const CLS = 'nearbyEventContainerBlock';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
// import rNearbyEventContainerBlock from './NearbyEventContainerBlock.jsx';
// import React from 'react';
// import ReactDOM from 'react-dom';

export class NearbyEventContainerBlock {
	constructor($el) {
		// $el is the blk node return by the loadNearbyEventContainerBlock function
		this.$el = $el;
	}

	init() {
		this.setNearbyEventContainerBlock();
	}

	setNearbyEventContainerBlock() {
		// Add Some logic here
		const $blk = $(this.$el);
		let slider = $blk.find(BLK + 'slider');

		const slickOptions = {
			autoPlay: true,
			arrows: false,
			mobileFirst: true,
			dots: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					},
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		};

		slider.slick(slickOptions);
	}

	// Add more functions like on above here
}
